import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=42afabe8&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/footer.css?vue&type=style&index=0&id=42afabe8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42afabe8",
  null
  
)

export default component.exports